import { Component, OnInit } from '@angular/core';
import { User, SessionUser } from '../../service/modal/user';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { pincode } from '../../service/modal/pincode';
import { Observable, of, Subject } from 'rxjs';
import { LoginService } from '../../service/apiservice/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../../globals';
import { UtilFunctions } from '../../util-functions';
import { HealthHistory } from '../../service/modal/healthhistory';
import { DoctorService } from '../../service/apiservice/doctor.service';
import { CampRegistrationService } from '../../service/apiservice/campregistration.service';
import { WebcamImage } from 'ngx-webcam';
import { UploadFileS3BucketService } from '../../service/apiservice/uploadFileS3Bucket.service';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-update-camp-register-user',
  templateUrl: './update-camp-register-user.component.html',
  styleUrls: ['./update-camp-register-user.component.css']
})
export class UpdateCampRegisterUserComponent implements OnInit {

  userInfo: User;
  userForm: FormGroup;
  submitted = false;
  options;
  bloodgroupsDropDown: String[] = ["Don't Know", "A Positive", "A Negative", "B Negative", "B Positive", "AB Negative", "AB Positive", "O Negative", "O Positive"];
  bloodDropDown_SelectedId: number[];
  pincodeDropDown: any;
  pincodeDropDown_SelectedId: number[];
  genderDropDown: String[] = ["None", "Male", "Female", "Other", "Transgender"];
  genderDropDown_SelectedId: number[];
  pincodeList: pincode[];
  filteredOptions: Observable<pincode[]>;
  selectedPincode;
  pincode;
  selectedItems = [];
  dropdownSettings = {};
  healthHistoryList: HealthHistory[] = new Array();

  userRegId;
  healthhistory = "";

  selectedFiles: File[] = new Array();
  imgurl: any;
  userObj: User;
  
  profileImgCharString: String[] = ['A.png', 'B.png', 'C.png', 'D.png', 'E.png', 'F.png', 'G.png', 'H.png', 'I.png', 'J.png', 'K.png', 'L.png', 'M.png', 'N.png', 'O.png', 'P.png', 'Q.png', 'R.png', 'S.png', 'T.png', 'U.png', 'V.png', 'W.png', 'X.png', 'Y.png', 'Z.png'];
  constructor(private spinner: NgxSpinnerService, private uploadService: UploadFileS3BucketService, private _campService: CampRegistrationService, private route: ActivatedRoute, private _loginService: LoginService, private _doctorService: DoctorService, private global: Globals, private router: Router, private formBuilder: FormBuilder) { }

  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);

    $(document).ready(function () {
      $("#webCamCampUser").hide();
      $("#snapshotCampUser").hide();
      $('#othertextfield').hide();
      $("#campUserProfilepic").hide();
    });
    this.loadEmptyCustomerForm();
    this.route.params.subscribe(params => this.userRegId = params['id']);
   
    this.getUserInfoById();
    // this.userInfo=this.global.loggedUser.user;

    this.healthHistoryList = [
      { id: 0, itemName: "Acidity" },
      { id: 1, itemName: "Arthritis" },
      { id: 2, itemName: "Asthma" },
      { id: 3, itemName: "Blood pressure" },
      { id: 4, itemName: "Cancer / Cancer History" },
      { id: 5, itemName: "Cholesterol" },
      { id: 6, itemName: "Diabetes" },
      { id: 7, itemName: "Epilapsy" },
      { id: 8, itemName: "Gastric Ulcer" },
      { id: 9, itemName: "Heart Disease" },
      { id: 10, itemName: "HIV" },
      { id: 11, itemName: "Hypertension" },
      { id: 12, itemName: "Other" },
      { id: 13, itemName: "Pregnancy / Breastfeeding" },
      { id: 14, itemName: "Thyroid" }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Health History",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes:"myclass custom-class"
    };
  }

  getUserInfoById() {
    this._loginService.getUserById(this.userRegId).subscribe(response => {
      this.userInfo = response;
      this.imgurl = "";

      this.loadWithDataCustomerForm(this.userInfo);
      $("#campUserProfilepic").show();
      this.loadHealthHistory();
    }, err => { });

  }






  loadEmptyCustomerForm() {
    this.userForm = this.formBuilder.group({
      'user_reg_id': ['', Validators.required],
      'firstName': ['', Validators.required],
      'middleName': ['', ''],
      'lastName': ['', ''],
      'gender': ['', Validators.required],
      'bloodGroup': ['', ''],
      'dob': ['', Validators.required],
      'age': ['', Validators.required],
      'pinCode': ['', Validators.required],
      'postalAddress': ['', Validators.required],
      'emailAddress': ['', Validators.required],
      'address': ['', ''],
      'emergencyName': ['', ''],
      'emergencyConatctNo': ['', ''],
      // 'policyNo':['',''],
      // 'policyName':['','']
      'policyDetails': ['', ''],
      'personalEmailId': ['', ''],
      'healthHistory': ['', ''],
      'other': ['', ''],
      'profileImgPath': ['', ''],
      'healthHistorySetCombo':['',''],

    });
  }

  loadWithDataCustomerForm(user: User) {
    debugger;
    this.userForm = this.formBuilder.group({
      'user_reg_id': [user.user_reg_id],
      "firstName": [user.firstName, Validators.required],
      'middleName': [user.middleName, ''],
      'lastName': [user.lastName, ''],
      'gender': [user.gender, Validators.required],
      'bloodGroup': [user.bloodGroup, ''],
      'dob': [user.dob, Validators.required],
      'age': [user.age, Validators.required],
      'pinCode': [user.pinCode, Validators.required],
      'postalAddress': [user.postalAddress, Validators.required],
      'emailAddress': [user.emailAddress, Validators.required],
      'address': [user.address, ''],
      'emergencyName': [user.emergencyName, ''],
      'emergencyConatctNo': [user.emergencyConatctNo, ''],
      //  'policyNo':[user.policyNo,''],
      //  'policyName':[user.pollicyName,''],
      'policyDetails': [user.policyDetails, ''],
      'personalEmailId': [user.personalEmailId, ''],
      'healthHistory': ['', ''],
      'other': [user.other, ''],
      'profileImgPath': [user.profileImgPath, ''],
      'healthHistorySetCombo':['',''],
    });
    this.selectedPincode = user.postalAddress;

  }

  createEmailId() {
    var name = this.userForm.get('firstName').value
    // var emailid=  this.userForm.get('emailAddress').value;
    // var newemailid=emailid.split(".")[0]+"."+this.userForm.get('firstName').value+"@mdhl.in";

    var newemailid = this.userInfo.mobileNumber + "." + name.toLowerCase() + "@mdhl.in"
    this.userForm.controls['emailAddress'].setValue('');
    this.userForm.controls['emailAddress'].setValue(newemailid);
  }
  UpdateUser() {
    debugger;
    this.submitted = true;
    if (this.userForm.invalid) {
      return;
    }

    for (var i = 0; i < this.selectedItems.length; i++) {

      this.healthhistory = this.healthhistory + this.selectedItems[i].itemName + ",";
      if (this.selectedItems[i].itemName == 'Other') {

      }
    }
    this.userForm.controls['healthHistory'].setValue(this.healthhistory);
    console.log(this.userForm.value);

    if (this.selectedFiles.length > 0) {
      this.changeProfilePic(this.userForm.get('user_reg_id').value);
    }
    if (this.webcamImage != null) {
      this.changeProfilePic(this.userForm.get('user_reg_id').value);
    }

    this._campService.updateCampRegiserUser(this.userForm.value)
      .subscribe((response) => {
        this.healthhistory = "";

       
        this.spinner.hide();
        info_noti('User Profile Updated Successfully');

        // window.location.reload();
        this.selectedPincode = "";
        this.selectedItems = [];
        this.clearprofilePic();
        this.healthhistory = "";



        this.router.navigate(['/doctordashboard/doctorpage']);
      },
        error => {
          info_noti('update failed');
          console.log(error);
        })


  }
  ageCalculator() {

    // let { AgeFromDateString } = require('age-calculator');

    // let ageFromString = new AgeFromDateString(this.userForm.get('dob').value).age;
    let ageFromString = this.getAge(this.userForm.get('dob').value);
    this.userForm.controls['age'].setValue(ageFromString);
    // this.age = ageFromString;

    console.log("value from ageFromString", ageFromString);

  }

  getAge(dateString) {
    if(dateString!==""){
    var now = new Date();

    var dob = new Date(dateString.substring(0, 4),
      dateString.substring(5, 7) - 1,
      dateString.substring(8, 10), now.getHours(), now.getMonth(), now.getSeconds()
    );



    //Get difference between years
    var years = now.getFullYear() - dob.getFullYear();
    var currMonth = now.getMonth() + 1;
    var birthMonth = dob.getMonth() + 1;
    var months = 0;
    var days = 0;
    //Get difference between months
    months = currMonth - birthMonth;

    //if month difference is in negative then reduce years by one 
    //and calculate the number of months.
    if (months < 0) {
      years--;
      months = 12 - birthMonth + currMonth;
      if (now.getDate() < dob.getDate())
        months--;
    } else if (months == 0 && now.getDate() < dob.getDate()) {
      years--;
      months = 11;
    }

    //Calculate the days
    if (now.getDate() > dob.getDate())
      days = now.getDate() - dob.getDate();
    else if (now.getDate() < dob.getDate()) {
      var today = now.getMonth();
      now.getMonth(), -1;
      days = now.getMonth() - dob.getMonth() + today;
    }
    else {
      days = 0;
      if (months == 12) {
        years++;
        months = 0;
      }
    }
    //Create new Age object 
    // return new Age(days, months, years);


    if (years > 0) {

      return years + " Years";
    } else if (months > 0) {

      return months + " Months";
    } else {

      return days + " Days";
    }
  }



  }



  getSelectedPincode(event) {
    $("selectFilter").val(event.option.value.pincode);
    this.pincode = event.option.value.pincode;
    this.selectedPincode = event.option.value.pincode + "-" + event.option.value.postofficenamearea + "," + event.option.value.districtname + "," + event.option.value.statename + " [" + event.option.value.divisionname + "]";
    this.userForm.controls['pinCode'].setValue(event.option.value.pincode);
    this.userForm.controls['postalAddress'].setValue(this.selectedPincode);

    console.log(this.selectedPincode);
  }
  getpincode() {

    if (this.userForm.get('pinCode').value.length == 6) {
      this._loginService.GetPincode(this.userForm.get('pinCode').value).subscribe((response) => {
        // this.pincodeDropDown=response;
        this.pincodeList = response;
        this.filteredOptions = of(this.pincodeList);
        console.log(this.pincodeList);
      }, error => {
        this.selectedPincode = "";
      });
    }

  }
  emergencyContactNo() {
    $(document).ready(function () {
      $("#emergencyContactNo").keypress(function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          $("#errmsg").html("Digits Only").show().fadeOut("slow");
          return false;
        }
      });
    });
  }

  addCancelClick(form: NgForm) {
    form.reset();
    this.router.navigate(['/doctordashboard/doctorpage']);
  }




  loadHealthHistory() {
    if (this.userInfo != undefined) {
      if (this.userInfo.healthHistory != null) {
        this.selectedItems = [];
        var healthhistoryarr = this.userInfo.healthHistory.split(",");
        var removeduplicate = Array.from(new Set(healthhistoryarr));
        console.log(removeduplicate);
        for (var i = 0; i < removeduplicate.length; i++) {
          if (removeduplicate[i] != "") {

            this.healthHistoryList.forEach(element => {
              if (removeduplicate[i] == element.itemName) {
                if (removeduplicate[i] == 'Other') {
                  this.userForm.controls['healthHistory'].setValue(this.healthhistory);
                  this.userForm.controls['other'].setValue(this.userInfo.other);
                  // $('#otherhealthhistory').val(this.userInfo.other);
                  $('#othertextfield').show();
                }
                this.selectedItems.push(element);
              }
            });
          }
        }
        console.log(this.selectedItems);
      }
    }
  }













  onItemSelect(item: any) {
    console.log(item);
    if (item.itemName == "Other") {
      $('#othertextfield').show();
    }

    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    if (item.itemName == 'Other') {
      $('#othertextfield').hide();

      this.userForm.controls['other'].setValue('');
    }
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {

    console.log(items);
    for (var i = 0; i < items.length; i++) {
      if (items[i].itemName == 'Other') {
        $('#othertextfield').show();
      }
    }


  }
  onDeSelectAll(items: any) {
    console.log(items);
    if (items.length == 0) {
      $('#othertextfield').hide();

      this.userForm.controls['other'].setValue('');
    }

  }


  public seconds: number;
  private trigger: Subject<void> = new Subject<void>();

  // latest snapshot
  public webcamImage: WebcamImage = null;
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info("received webcam image", webcamImage);
    this.webcamImage = webcamImage;
    $("#webCamCampUser").hide();
    $("#snapshotCampUser").show();
    $("#campUserProfilepic").hide();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  openWebCam() {

    this.imgurl = "";
    $("#snapshotCampUser").hide();
    $("#webCamCampUser").show();
    $("#takephotoCampUser").attr("disabled", true);
    $("#campUserProfilepic").hide();

    // this.triggerSnapshot();
  }
  uploadPicHideWebCam() {
    this.webcamImage = null;
    $("#snapshotCampUser").hide(); false
    $("#webCamCampUser").hide();
    $("#takephotoCampUser").attr("disabled", false);
    $("#campUserProfilepic").hide();
  }

  clearprofilePic() {
    this.imgurl = "";
    this.webcamImage = null;
    $("#snapshotCampUser").hide();
    $("#webCamCampUser").hide();
    $("#takephotoCampUser").attr("disabled", false);
    $("#campUserProfilepic").hide();
    $('#othertextfield').hide();
    $("#printBtn").hide();

  }


  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFiles = event.target.files;
      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.imgurl = reader.result;
      }
    }

  }
  changeProfilePic(userid) {
    if (this.webcamImage != null) {
      this.selectedFiles = new Array;
      var bytearray = this.base64ToByteArray(this.webcamImage.imageAsBase64);
      var file = new File([new Blob(bytearray)], "profile", { type: "image/jpeg" });
      this.selectedFiles[0] = file;
    }

    if (this.selectedFiles.length > 0) {

      this.uploadService.uploadCampRegisterUserProfileImg(this.selectedFiles, userid);
    }
    setTimeout(() => {
      if (Globals.attachmentStatus == true) {
        var path = "https://mdhl.s3.ap-south-1.amazonaws.com/" + userid + "/profileImg." + "jpeg";
        this.userObj = new User();
        this.userObj.user_reg_id = userid;
        this.userObj.profileImgPath = path;
        this.userForm.controls['profileImgPath'].setValue(path);
        Globals.attachmentStatus = false;
        // this._loginService.uploadProfileImg(this.userObj).subscribe((response) => {
        //   if (response != null) {
        //     this.selectedFiles = new Array;
        //     this.webcamImage = null;
        //     Globals.attachmentStatus = false;


        //   }
        // }, err => { });
      } else {
        info_noti("Please Wait For Upload Profile Img")
        this.spinner.hide();
        return false;

      }
    }, 5000);


  }



  base64ToByteArray(base64String) {
    try {
      var sliceSize = 1024;
      var byteCharacters = atob(base64String);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return byteArrays;
    } catch (e) {
      console.log("Couldn't convert to byte array: " + e);
      return undefined;
    }
  }

  removeImage() {
    debugger;
    this.imgurl = "";
    this.selectedFiles = new Array;
    this.webcamImage = null;
    $("#snapshotCampUser").hide();
    $("#webCamCampUser").hide();
    $("#takephotoCampUser").attr("disabled", false);

    if (this.userInfo != null) {
      var firstletter = this.userForm.get('firstName').value.charAt(0);
      var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
      for (let i = 0; i < this.profileImgCharString.length; i++) {
        // console.log(this.profileImgCharString[i].charCodeAt(0))
        var first = this.profileImgCharString[i].split(".")[0];
        if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
          profileImgPath = profileImgPath + this.profileImgCharString[i];
          break;
        }
      }

      // this.userObj = new User();
      // this.userObj.user_reg_id = this.userForm.get('user_reg_id').value;
      // this.userObj.profileImgPath = profileImgPath;


      this.userForm.get('profileImgPath').setValue(profileImgPath);
      $("#campUserProfilepic").hide();


      // this._loginService.uploadProfileImg(this.userObj).subscribe((response) => {
      //   if (response != null) {


      //   }
      // }, err => { });
    }
  }












  firstNameEnter() {
    $('#middleName').focus();
  }
  middelNameEnter() {
    $('#lastName').focus();
  }
  lastNameEnter() {
    $('#mdhlId').focus();
  }
  mdhlIdEnter() {
    $('#gender').focus();
  }
  genderEnter() {
    $('#bloodgroup').focus();
  }
  bloodGroupEnter() {
    $('#dob').focus();
  }
  dobEnter() {
    $('#age').focus();
    this.ageCalculator();
  }
  ageEnter() {
    $('#emailId').focus();
  }
  emailIdEnter() {
    $('#address').focus();
  }
  addressEnter() {
    $('#pincode').focus();
  }
  pincodeEnter() {
    $('#emergencyContactNo').focus();
  }
  emergencyContactNoEnter() {
    $('#emergencyName').focus();
  }

  emergencyNameEnter() {
    $('#policyDetails').focus();
  }
  policyDetailsEnter() {
    $('#updateBtn').focus();
    this.UpdateUser();

  }






}

